// src/components/DashContentBuilder.js
import React, { useEffect, useState } from "react";
import {
  collection,
  getDocs,
  addDoc,
  updateDoc,
  deleteDoc,
  doc,
} from "firebase/firestore";
import { db } from "../firebase";

const DashContentBuilder = () => {
  const [sections, setSections] = useState([]);
  const [activeTab, setActiveTab] = useState("staff");
  const [newSectionName, setNewSectionName] = useState("");
  const [fieldInputs, setFieldInputs] = useState({});

  useEffect(() => {
    fetchSections();
  }, []);

  const fetchSections = async () => {
    const snap = await getDocs(collection(db, "dashContent"));
    const fetched = snap.docs.map((d) => ({
      id: d.id,
      ...d.data(),
    }));
    setSections(fetched);
  };

  const addSection = async () => {
    if (!newSectionName.trim()) return;
    const docRef = await addDoc(collection(db, "dashContent"), {
      name: newSectionName,
      fields: [],
    });
    setSections([
      ...sections,
      { id: docRef.id, name: newSectionName, fields: [] },
    ]);
    setNewSectionName("");
  };

  const deleteSection = async (id) => {
    await deleteDoc(doc(db, "dashContent", id));
    setSections(sections.filter((s) => s.id !== id));
  };

  const handleFieldInput = (sectionId, key, value) => {
    setFieldInputs((prev) => ({
      ...prev,
      [sectionId]: {
        ...prev[sectionId],
        [key]: value,
      },
    }));
  };

  const addFieldToSection = async (sectionId) => {
    const inputs = fieldInputs[sectionId] || {};
    if (!inputs.label || !inputs.type) return;
    const updated = sections.map((s) => {
      if (s.id === sectionId) {
        const newFields = [
          ...s.fields,
          { label: inputs.label, type: inputs.type },
        ];
        updateDoc(doc(db, "dashContent", sectionId), { fields: newFields });
        return { ...s, fields: newFields };
      }
      return s;
    });
    setSections(updated);
    setFieldInputs((prev) => ({
      ...prev,
      [sectionId]: { label: "", type: "" },
    }));
  };

  const deleteField = async (sectionId, index) => {
    const section = sections.find((s) => s.id === sectionId);
    const updatedFields = section.fields.filter((_, i) => i !== index);
    await updateDoc(doc(db, "dashContent", sectionId), {
      fields: updatedFields,
    });
    setSections(
      sections.map((s) =>
        s.id === sectionId ? { ...s, fields: updatedFields } : s
      )
    );
  };

  return (
    <div style={{ maxWidth: 700, margin: "40px auto", fontFamily: "Arial" }}>
      <h2 style={{ textAlign: "center" }}>⚙️ Admin Panel</h2>

      {/* Tabs */}
      <div style={{ display: "flex", justifyContent: "center", marginBottom: 20 }}>
        <button
          onClick={() => setActiveTab("staff")}
          style={{
            background: activeTab === "staff" ? "#333" : "#999",
            color: "white",
            padding: "10px 20px",
            marginRight: 10,
            border: "none",
            borderRadius: 4,
          }}
        >
          🧑‍🍳 Staff Dashboard
        </button>
        <button
          disabled
          style={{
            background: "#bbb",
            padding: "10px 20px",
            border: "none",
            borderRadius: 4,
          }}
        >
          👨‍💼 Managers
        </button>
        <button
          disabled
          style={{
            background: "#bbb",
            padding: "10px 20px",
            border: "none",
            borderRadius: 4,
            marginLeft: 10,
          }}
        >
          ⚙️ Settings
        </button>
      </div>

      {/* Staff Dashboard Content */}
      {activeTab === "staff" && (
        <>
          <div style={{ marginBottom: 20 }}>
            <input
              placeholder="New Section Name"
              value={newSectionName}
              onChange={(e) => setNewSectionName(e.target.value)}
              style={{
                padding: 10,
                width: "60%",
                marginRight: 10,
                borderRadius: 4,
                border: "1px solid #ccc",
              }}
            />
            <button
              onClick={addSection}
              style={{
                padding: 10,
                background: "#4CAF50",
                color: "white",
                border: "none",
                borderRadius: 4,
              }}
            >
              Add Section
            </button>
          </div>

          {sections.map((section) => (
            <div
              key={section.id}
              style={{
                border: "1px solid #ddd",
                padding: 15,
                borderRadius: 8,
                marginBottom: 20,
              }}
            >
              <div
                style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}
              >
                <h3 style={{ margin: 0 }}>{section.name}</h3>
                <button
                  onClick={() => deleteSection(section.id)}
                  style={{
                    background: "red",
                    color: "white",
                    padding: "5px 10px",
                    border: "none",
                    borderRadius: 4,
                  }}
                >
                  Delete Section
                </button>
              </div>

              {/* Fields */}
              {section.fields?.map((field, index) => (
                <div
                  key={index}
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    margin: "8px 0",
                    padding: "6px 10px",
                    background: "#f9f9f9",
                    borderRadius: 4,
                  }}
                >
                  <span>
                    <b>{field.label}</b> ({field.type})
                  </span>
                  <button
                    onClick={() => deleteField(section.id, index)}
                    style={{
                      background: "transparent",
                      border: "none",
                      fontSize: 18,
                      color: "#d00",
                      cursor: "pointer",
                    }}
                  >
                    ❌
                  </button>
                </div>
              ))}

              {/* Add Field */}
              <div style={{ marginTop: 10 }}>
                <input
                  placeholder="Field Label"
                  value={fieldInputs[section.id]?.label || ""}
                  onChange={(e) => handleFieldInput(section.id, "label", e.target.value)}
                  style={{
                    padding: 8,
                    width: "40%",
                    marginRight: 8,
                    borderRadius: 4,
                    border: "1px solid #ccc",
                  }}
                />
                <select
                  value={fieldInputs[section.id]?.type || ""}
                  onChange={(e) => handleFieldInput(section.id, "type", e.target.value)}
                  style={{
                    padding: 8,
                    width: "30%",
                    marginRight: 8,
                    borderRadius: 4,
                    border: "1px solid #ccc",
                  }}
                >
                  <option value="">Type</option>
                  <option value="text">Text</option>
                  <option value="number">Number</option>
                  <option value="checkbox">Checkbox</option>
                  <option value="photo">Photo</option>
                </select>
                <button
                  onClick={() => addFieldToSection(section.id)}
                  style={{
                    padding: 8,
                    background: "#2196F3",
                    color: "white",
                    border: "none",
                    borderRadius: 4,
                  }}
                >
                  ➕ Add Field
                </button>
              </div>
            </div>
          ))}
        </>
      )}
    </div>
  );
};

export default DashContentBuilder;
